import * as React from 'react';
import {StyleSheet} from 'react-native';

import EditScreenInfo from '../components/EditScreenInfo';
import {Text, View} from '../components/Themed';
import AddressSearch from '../components/AddressSearch';
// import PlacesAutocomplete from '../components/PlacesAutocomplete';

export default function RoutingScreen() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Find the best connection from A to B</Text>
      <View
        style={styles.separator}
        lightColor="#eee"
        darkColor="rgba(255,255,255,0.1)"
      />

      <AddressSearch addressType="start" zIndex="100" />
      <AddressSearch addressType="destination" zIndex="50" />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  separator: {
    marginVertical: 30,
    height: 1,
    width: '80%',
  },
  addressView: {
    marginTop: '20px',
    marginBottom: '20px',
  }
});
